import { BaseEntity } from "@app/models/rest/base-entity";
import { VisitType } from "@app/models/rest/visit-type";
import { SkillProfile } from "@app/models/rest/skill-profile";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRel
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("visitTypeResources")
export class VisitTypeResource extends BaseEntity {
  visitType: VisitType;
  skillProfile: SkillProfile;
  hideInspection: boolean;
  hideSchedules: boolean;
  hideMaterials: boolean;
}

@HateoasProjection(VisitTypeResource, "detail")
export class VisitTypeResource_DetailProjection extends BaseEntity {
  @ProjectionRel(VisitType)
  visitType: VisitType;
  @ProjectionRel(SkillProfile)
  skillProfile: SkillProfile;
  hideInspection: boolean;
  hideSchedules: boolean;
  hideMaterials: boolean;
}
